import BulkClassService from '../../../services/bulk-classes.service';
import ClassService from '../../../services/classes.service';
import ProviderService from '../../../services/providers.service';
import axios from 'axios'

var CancelToken = axios.CancelToken;
var Source = null;

export async function getClasses(store, filters) {
    try {
        const state = store.state;
        let newFilters = filters || state.ClassList.filters;
        store.setState({ ClassList: { ...state.ClassList, filters: newFilters } });

        if (Source) {
            Source.cancel();
        }
        Source = CancelToken.source();
        const items = await BulkClassService().getClasses(newFilters, Source.token);
        Source = null;
        store.setState({ ClassList: { ...store.state.ClassList, items, filters: newFilters } });
    }
    catch (error) {
        if (axios.isCancel(error)) {
            console.log('request cancelled');
        }
        else {
            throw error;
        }
    }
}

export async function updateClassMapping(store, { className, classGroupId, newClassGroupId, displayLabel }) {
    await BulkClassService().updateClassMapping(className, classGroupId, newClassGroupId, displayLabel);
}


export async function getClassGroups(store) {
    const classGroups = await ClassService().getClassGroups();
    store.setState({ ClassList: { ...store.state.ClassList, classGroups } });
}

export async function getProviders(store) {
    const providers = await ProviderService().getAllProviders();
    store.setState({ ClassList: { ...store.state.ClassList, providers } })
}